export default __webpack_public_path__ + "/dist/images/3640469.12de8a4ce0da8baafc23e7bda5633303.png";